// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import Slider from "rc-slider";
// import "rc-slider/assets/index.css";
// import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
// import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
// import DatePicker from "react-datepicker";
// import SearchCB from "../../Assets/Images/CreateRole/Search.png";
// import "react-datepicker/dist/react-datepicker.css";
// import format from "date-fns/format"; // Add this line
// import DropDownCB from "./DropdownCB";
// import Dropdown from "../../Components/Shared/Dropdown/Dropdown";
// import SelectDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
// import InformativeIcon from "../../Assets/Images/CommanImages/Informative.png";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import WarningIcon from "../../Assets/Images/CommanImages/Warning.png";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import SelectedValue from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import "./CreateBatch.css";
// import SelectedStudentTable from "./SelectedStudentTable";

// const EditCreateBatch = ({ dataClient, setMessageBox, setIsMessageBoxVisible, setActiveImg, SuccessImg }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const batchData = location.state;
//   const [sliderValue, setSliderValue] = useState([65, 70]);
//   const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
//   const handleSliderChange = (value) => { setSliderValue(value); };
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(25);
//   const [selectedButton, setSelectedButton] = useState(25);
//   const user_name = dataClient?.client_schema_name[6][0].user_name;
//   const [assignedStudents, setAssignedStudents] = useState([]);
//   const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
//   const [studentTypeId, setStudentTypeId] = useState(3);
//   const [activeToggle, setActiveToggle] = useState(null);
//   const [toggleKey, setToggleKey] = useState(0);
//   const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [batchName, setBatchName] = useState("");
//   const [courseOpted, setCourseOpted] = useState("");
//   const [coachingMode, setCoachingMode] = useState("");
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [selectedClassName, setSelectedClassName] = useState("");
//   const [selectedCourseId, setSelectedCourseId] = useState(null);
//   const [studentData, setStudentData] = useState([]);
//   const [selectedClassObj, setSelectedClassObj] = useState(null);
//   const [initialData, setInitialData] = useState([]);
//   const [firstTableData, setFirstTableData] = useState([]);
//   const [secondTableData, setSecondTableData] = useState([]);
//   const [excludeAssigned, setExcludeAssigned] = useState(false);
//   const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
//   const clientBranchId = dataClient?.client_schema_name[6][0].client_branch_id;
//   const clientId = dataClient?.client_schema_name[6][0].client_id;
//   const [batchDescription, setBatchDescription] = useState("");
//   const [batchCode, setBatchCode] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [firstSearchTerm, setFirstSearchTerm] = useState("");
//   const [secondSearchTerm, setSecondSearchTerm] = useState("");
//   const [isOpenBasicInfo, setIsOpenBasicInfo] = useState(true);
//   const [isOpenAssignStudent, setIsOpenAssignStudent] = useState(true);
//   const [selectedMentor, setSelectedMentor] = useState("N/A");
//   const [sessionData, setSessionData] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState("");
//   const [selectedClassId, setSelectedClassId] = useState("");
//   const [selectedCoachingModeId, setSelectedCoachingModeId] = useState("");
//   const searchParams = new URLSearchParams(location.search);
//   const batchId = searchParams.get("batchId");
//    const accessToken = localStorage.getItem("other");
//    const [batchStatus, setBatchStatus] = useState(1);
//   const coachingModeOptions = [
//     { id: 1, label: "Online" },
//     { id: 2, label: "Classroom" },
//     { id: 3, label: "Hybrid" },
//   ];
//   const classTypeAbbreviations = {
//     Online: "OL",
//     Classroom: "CL",
//     Hybrid: "H",
//   };
//   const classTypeToId = {
//     Online: 1,
//     Classroom: 2,
//     Hybrid: 3,
//   };

//   const handleStyle = {
//     borderRadius: 0,
//     backgroundColor: "#EFEFEF",
//     border: "2px solid #999999",
//     height: "28px",
//     width: "20px",
//     opacity: 1,
//   };

//   const trackStyle = {
//     backgroundColor: "#D6D6D6",
//     height: "20px",
//     border: "1px solid #999999",
//   };

//   const railStyle = {
//     borderRadius: 0, // Add this line
//     backgroundColor: "#FFFFFF",
//     height: "20px",
//     border: "2px solid #999999",
//   };

//   const handleToggleChange = (type, val, typeId) => {
//     if (val === 1) {
//       setActiveToggle(type);
//       setStudentTypeId(typeId);
//       setToggleKey(prev => prev + 1); // resets the other two toggles
//     } else {
//       setActiveToggle(null);
//       setStudentTypeId(null);
//     }
//   };

//   const toggleBasicInfoAccordion = () => setIsOpenBasicInfo(prev => !prev);
//   const toggleAssignStudentAccordion = () => setIsOpenAssignStudent(prev => !prev);

//   useEffect(() => {
//     if (
//       batchData?.class_id &&
//       selectedClass.length > 0
//     ) {
//       const cls = selectedClass.find(
//         (item) => item.class_id === batchData.class_id
//       );

//       if (cls) {
//         setSelectedClassObj(cls);
//       }
//     }
//   }, [selectedClass, batchData]);

//   useEffect(() => {
//     if (!batchData) return;
//     setBatchName(batchData.batch_name || "");
//     setBatchDescription(batchData.batch_description || "");
//     setBatchCode(batchData.batch_code || "");
//     setSelectedSessionId(batchData.session_id || "");
//     setSelectedCourseId(batchData.course_id || "");
//     setSelectedClassId(batchData.class_id || "");
//     setCoachingMode(batchData.coaching_mode_id || "");
//     setSelectedCourseName(batchData.course_name || "");
//     setSelectedClassName(batchData.class_name || "");
//     setBatchStatus(batchData.status === "Active" ? 1 : 0);

//     if (batchData.exam_date) {
//       const date = new Date(batchData.exam_date);

//       setTentativeExamDate(
//         `${date.getFullYear()}-${String(
//           date.getMonth() + 1
//         ).padStart(2, "0")}`
//       );
//     }
//   }, [batchData]);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-courses/`
//       );
//       const data = await response.json();
//       setCourses(data);
//     };

//     fetchCourses();
//   }, []);

//   useEffect(() => {
//     const fetchClasses = async () => {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-classes/`
//       );
//       const data = await response.json();
//       setSelectedClass(data); // Save the entire class object in the state
//     };

//     fetchClasses();
//   }, []);

//   useEffect(() => {
//       if (selectedCourseId && selectedClassObj && studentTypeId) {
//         const fetchStudentData = async () => {
//           const response = await fetch(
//             `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
//           );
//           let data = await response.json();
//           data = mapEmptyBatchToNoBatch(data);
//           setStudentData(data);
//         };

//         fetchStudentData();
//       }
//     }, [selectedCourseId, selectedClassObj, studentTypeId]);

//   const handleCourseSelection = (selectedCourseId) => {
//     // Find the selected course object
//     const selectedCourse = courses.find(
//       (course) => course.course_id === selectedCourseId
//     );

//     // Set the selected course ID
//     setSelectedCourseId(selectedCourse.course_id);

//     // Set the selected course name
//     setSelectedCourseName(selectedCourse.course_name);
//   };

//   const handleClassSelection = (selectedClassId) => {
//     // Find the selected class object
//     const selectedClassObj = selectedClass.find(
//       (classObj) => classObj.class_id === selectedClassId
//     );

//     // Set the selected class object
//     setSelectedClassObj(selectedClassObj);

//     // Set the selected class name
//     setSelectedClassName(selectedClassObj.class_name);
//   };
//   const unassignStudents = () => {
//     const selectedStudentsCopy = secondTableData.filter((student) =>
//       selectedStudentIds.includes(student.student_id)
//     );

//     setFirstTableData((prevFirstTableData) => [
//       ...prevFirstTableData,
//       ...selectedStudentsCopy,
//     ]);
//     const newSecondTableData = secondTableData.filter(
//       (student) => !selectedStudentIds.includes(student.student_id)
//     );

//     // Update the secondTableData state with the new array
//     setSecondTableData(newSecondTableData);

//     // Reset the selectedStudentIds
//     setSelectedStudentIds([]);
//   };

//   useEffect(() => {
//     const newBatchCode = `${selectedCourseName}-${selectedClassName}-${classTypeAbbreviations[coachingMode]}-${batchName}`;
//     setBatchCode(newBatchCode);
//   }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

//   const updateBatch = async () => {
//     if (!batchName || !coachingMode || !selectedCourseId || !selectedClassObj || !selectedSessionId) {
//       setIsMessageBoxVisible(true);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Please fill all the required fields.</span>
//             </div>
//           </div>
//         );
//         if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
//       }
//       return;
//     }

//     const accessToken = localStorage.getItem("access_token");
//     const examDt = tentativeExamDate ? `${tentativeExamDate}-01 00:00:00.000` : "";
//     const payload = {
//       batch_id:          Number(batchData.batch_id),
//       batch_name:        batchName,
//       batch_description: batchDescription,
//       batch_code:        `${selectedCourseName}-${selectedClassName}-${classTypeAbbreviations[coachingMode] ?? ""}-${batchName}`,
//       coaching_mode_id:  classTypeToId[coachingMode],
//       tentative_exam_dt: examDt,
//       comments_:         "",
//       status:            batchStatus,
//       class_id:          selectedClassObj.class_id,
//       course_id:         selectedCourseId,
//       user_name:         user_name,
//     };

//     const doUpdate = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/update-batch`,
//           {
//             method: "PUT",
//             headers: {
//               "accept": "application/json",
//               "Content-Type": "application/json",
//               "Authorization": `Bearer ${accessToken}`,
//             },
//             body: JSON.stringify(payload),
//           }
//         );

//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Batch Updated Successfully.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InformativeIcon);
//         }
//         setTimeout(() => {
//           navigate("/batch_dashboard");
//         }, 2000);
//       } catch (error) {
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error updating batch. Please try again.</span>
//               </div>
//             </div>
//           );
//           if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
//         }
//       }
//     };

//     const hasAssignedStudents = secondTableData.some(
//       (student) => student.batch_name !== null && student.batch_name !== "Not Assigned"
//     );

//     if (hasAssignedStudents) {
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Some students are already batch-assigned. Are you sure you want to proceed?</span>
//             </div>
//             <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => { setIsMessageBoxVisible(false); doUpdate(); }}
//               >YES</button>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => setIsMessageBoxVisible(false)}
//               >NO</button>
//             </div>
//           </div>
//         );
//         if (setActiveImg && InformativeIcon) setActiveImg(InformativeIcon);
//         setIsMessageBoxVisible(true);
//       }
//     } else {
//       doUpdate();
//     }
//   };

//   const deleteBatch = async () => {
//     const doDelete = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/delete-batch/${batchData.batch_id}`,
//           {
//             method: "DELETE",
//             headers: {
//               "accept": "application/json",
//               "Authorization": `Bearer ${accessToken}`,
//             },
//           }
//         );

//         const result = await response.json();
//         if (result.status === 409) {
//           setIsMessageBoxVisible(true);
//           if (setMessageBox) {
//             setMessageBox(
//               <div className="Container-messageBOX">
//                 <div className="messagebox-insider1">
//                   <div className="loader-tc"></div>
//                   <span>{result.message}</span>
//                 </div>
//               </div>
//             );
//             setActiveImg(WarningIcon);
//           }
//           return;
//         }
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Batch Deleted Successfully.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InformativeIcon);
//         }
//         setTimeout(() => navigate("/batch_dashboard"), 2000);

//       } catch (error) {
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error deleting batch. Please try again.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(ErrorImg);
//         }
//       }
//     };

//     // YES / NO confirmation before delete
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Are you sure you want to delete this batch?</span>
//           </div>
//           <div
//             className="messagebox-insider2"
//             style={{ display: "flex", gap: "10px", marginTop: "10px" }}
//           >
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//                 doDelete();
//               }}
//             >
//               YES
//             </button>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => setIsMessageBoxVisible(false)}
//             >
//               NO
//             </button>
//           </div>
//         </div>
//       );
//       setActiveImg(InformativeIcon);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleStudentTypeSelection = (e) => {
//     const selectedStudentTypeName = e.target.value;
//     setStudentTypeId(classTypeToId[selectedStudentTypeName]);
//   };
//   useEffect(() => {
//     if (selectedCourseId && selectedClassObj && studentTypeId) {
//       const fetchStudentData = async () => {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
//         );
//         let data = await response.json();

//         data = mapEmptyBatchToNoBatch(data);

//         setStudentData(data); // Save the student data in the state
//       };

//       fetchStudentData();
//     }
//   }, [selectedCourseId, selectedClassObj, studentTypeId]);

//   const assignStudents = () => {
//     const selectedStudentsCopy = firstTableData.filter((student) =>
//       selectedStudentIds.includes(student.student_id)
//     );

//     setSecondTableData((prevSecondTableData) => [
//       ...prevSecondTableData,
//       ...selectedStudentsCopy,
//     ]);
//     const newFirstTableData = firstTableData.filter(
//       (student) => !selectedStudentIds.includes(student.student_id)
//     );

//     // Update the firstTableData state with the new array
//     setFirstTableData(newFirstTableData);

//     // Reset the selectedStudentIds
//     setSelectedStudentIds([]);
//   };

//   // In your render method, when a checkbox is clicked
//   const handleCheckboxClick = (studentId) => {
//     setSelectedStudentIds((prevSelectedStudentIds) => {
//       if (prevSelectedStudentIds.includes(studentId)) {
//         // If the student is already selected, unselect them
//         return prevSelectedStudentIds.filter((id) => id !== studentId);
//       } else {
//         // If the student is not selected, select them
//         return [...prevSelectedStudentIds, studentId];
//       }
//     });
//   };

//   // const mapEmptyBatchToNoBatch = (studentData) => {
//   //   return studentData.map((student) => ({
//   //     ...student,
//   //     batch_name: student.batch_name === "" ? "NoBatch" : student.batch_name,
//   //   }));
//   // };

//   const mapEmptyBatchToNoBatch = (studentData) => {
//   // Ensure studentData is an array
//   const dataArray = Array.isArray(studentData) ? studentData : studentData?.data || studentData?.students || [];

//   return dataArray.map((student) => ({
//     ...student,
//     batch_name: student.batch_name === "" ? "Not Assigned" : student.batch_name,
//   }));
// };

//   useEffect(() => {
//     // Clear the table first
//     setFirstTableData([]);

//     // Use setTimeout to allow for the table to clear before setting the new data
//     setTimeout(() => {
//       // If excludeAssigned is true, only include students where batch_name is null
//       if (excludeAssigned) {
//         setFirstTableData(
//           studentData.filter((student) => student.batch_name === null)
//         );
//       } else {
//         setFirstTableData(studentData);
//       }
//     }, 0); // setTimeout with 0 delay ensures the clear operation happens first
//   }, [excludeAssigned, studentData]);

//   const fetchSessionsData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-sessions-list`,
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200 && result.data) {
//         const formattedSessions = result.data.map((session) => ({
//           id: session.session_id,
//           label: session.session_name,
//         }));
//         setSessionData(formattedSessions);
//       }
//     } catch (error) {
//       console.error("Error fetching sessions data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSessionsData();
//   }, []);

//   const [isEditMode, setIsEditMode] = useState(false);

//   const headers = [
//     "Student ID",
//     "Roll Number",
//     "Student Name",
//     "Batch ID",
//     "Batch Name",
//     "Class Type ID",
//     "Mentor Name"
//   ];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading" style={{ color: "#6A6A6A" }}>Create Batch</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate(`/batch_dashboard`)}
//             style={{ backgroundColor: "#ffffff", color: "#424342" }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.backgroundColor = "#fa4741";
//               e.currentTarget.style.color = "white";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.backgroundColor = "#ffffff";
//               e.currentTarget.style.color = "#424342";
//             }}
//           >
//             CANCEL
//           </button>
//           <button
//             className="cr-cancel-btn"
//             onClick={() => deleteBatch()}
//             style={{
//               boxShadow: "0px 4px 4px 0px #00000040",
//               backgroundColor: "#ffffff",
//               cursor: "pointer",
//               color: "#424342",
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.backgroundColor = "#fa4741";
//               e.currentTarget.style.color = "white";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.backgroundColor = "#ffffff";
//               e.currentTarget.style.color = "#424342";
//             }}
//           >
//             DELETE
//           </button>
//           {isEditMode ? (
//             <button
//               className="cr-cancel-btn"
//               onClick={() => {
//                 updateBatch();
//                 setIsEditMode(false);
//               }}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: "#ffffff",
//                 cursor: "pointer",
//                 color: "#424342",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = "#fa4741";
//                 e.currentTarget.style.color = "white";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = "#ffffff";
//                 e.currentTarget.style.color = "#424342";
//               }}
//             >
//               SAVE
//             </button>
//           ) : (
//             <button
//               className="cr-cancel-btn"
//               onClick={() => setIsEditMode(true)}
//               style={{
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: "#ffffff",
//                 cursor: "pointer",
//                 color: "#424342",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = "#fa4741";
//                 e.currentTarget.style.color = "white";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = "#ffffff";
//                 e.currentTarget.style.color = "#424342";
//               }}
//             >
//               EDIT
//             </button>
//           )}

//         </div>
//       </div>
//       <div className="parse-tagging">
//         <div className="personal-header">
//           <div className="header">
//             <h2>BATCH DETAILS</h2>
//           </div>
//           <div className="accordion-btn" onClick={toggleBasicInfoAccordion}>
//             {isOpenBasicInfo ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenBasicInfo && (
//           <div className="accordion-content-tagging-container">
//             <div className="grid-container-tagging">
//               <div className="grid-item">
//                 <FormInputs
//                   label="Batch Name"
//                   value={batchName}
//                   onChange={(e) => setBatchName(e.target.value)}
//                   required
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Description"
//                   value={batchDescription}
//                   onChange={(e) => setBatchDescription(e.target.value)}
//                   required
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//               <FormInputs
//                   label="Batch Code"
//                   value={batchCode}
//                   disabled
//                   readOnly
//                 />
//               </div>
//               <div className="grid-item">
//                 <SelectDropdown
//                   label="Session"
//                   style={{ width: "100%" }}
//                   selected={selectedSessionId}
//                   setSelected={setSelectedSessionId}
//                   options={sessionData}
//                   isRequired={true}
//                   disabled={!isEditMode}
//                 />
//               </div>
//                <div className="grid-item">
//                 <SelectDropdown
//                   label="Course"
//                   selected={selectedCourseId}
//                   style={{ width: "100%" }}
//                   setSelected={handleCourseSelection}
//                   options={courses.map((course) => ({
//                     id: course.course_id,
//                     label: course.course_name,
//                   }))}
//                   isRequired={true}
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <SelectDropdown
//                   label="Class"
//                   style={{ width: "100%" }}
//                   selected={selectedClassObj ? selectedClassObj.class_id : ""}
//                   setSelected={handleClassSelection}
//                   options={selectedClass.map((classObj) => ({
//                     id: classObj.class_id,
//                     label: classObj.class_name,
//                   }))}
//                   isRequired={true}
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <SelectDropdown
//                   label="Batch Coaching Mode"
//                   selected={coachingMode}
//                   style={{ width: "100%" }}
//                   setSelected={setCoachingMode}
//                   options={coachingModeOptions}
//                   isRequired={true}
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Tentative Exam Date"
//                   type="month"
//                   value={tentativeExamDate}
//                   onChange={(e) => setTentativeExamDate(e.target.value)}
//                   required
//                   min={new Date().toISOString().slice(0, 7)}
//                   disabled={!isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <SelectedValue
//                   label="Mentor"
//                   style={{ width: "100%" }}
//                   selected={selectedMentor}
//                   setSelected={setSelectedMentor}
//                   options={[{ id: "N/A", label: "N/A" }]}
//                   isRequired={true}
//                   disabled={!isEditMode}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="parse-tagging">
//         <div className="personal-header">
//           <div className="header">
//             <h2>ASSIGN STUDENT(S)</h2>
//           </div>
//           <div className="accordion-btn" onClick={toggleAssignStudentAccordion}>
//             {isOpenAssignStudent ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenAssignStudent && (
//           <div className="accordion-content-tagging-container">
//             <div className="accordion-content-tagging-container">
//               {/* <div className="grid-container-tagging"> */}
//                <div style={{ gridColumn: "1 / -1", paddingTop: "20px", paddingBottom: "20px" }} >
//                   <SelectedStudentTable
//                     headers={headers}
//                     data={studentData.map(student => [
//                       student.student_id,
//                       student.roll_number,
//                       student.full_name,
//                       student.batch_id,
//                       student.batch_name,
//                       student.class_type_id,
//                       student.mentor_name,
//                     ])}
//                     searchPlaceholder="Search Students..."
//                   />
//                 </div>
//               {/* </div> */}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EditCreateBatch;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import DatePicker from "react-datepicker";
import SearchCB from "../../Assets/Images/CreateRole/Search.png";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format";
import DropDownCB from "./DropdownCB";
import Dropdown from "../../Components/Shared/Dropdown/Dropdown";
import SelectDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import { FULL_API_BASE_URL } from "../../Config/Config";
import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
import InformativeIcon from "../../Assets/Images/CommanImages/Informative.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import WarningIcon from "../../Assets/Images/CommanImages/Warning.png";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import SelectedValue from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import "./CreateBatch.css";
import SelectedStudentTable from "./SelectedStudentTable";

const EditCreateBatch = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  SuccessImg,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const batchData = location.state;
  const [sliderValue, setSliderValue] = useState([65, 70]);
  const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedButton, setSelectedButton] = useState(25);
  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
  const [studentTypeId, setStudentTypeId] = useState(3);
  const [activeToggle, setActiveToggle] = useState(null);
  const [toggleKey, setToggleKey] = useState(0);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [courseOpted, setCourseOpted] = useState("");

  // ✅ coachingMode now stores numeric ID (same as selectedCourseId, selectedClassId, selectedSessionId)
  const [coachingMode, setCoachingMode] = useState("");

  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedClassObj, setSelectedClassObj] = useState(null);
  const [initialData, setInitialData] = useState([]);
  const [firstTableData, setFirstTableData] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [excludeAssigned, setExcludeAssigned] = useState(false);
  const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
  const clientBranchId = dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient?.client_schema_name[6][0].client_id;
  const [batchDescription, setBatchDescription] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [firstSearchTerm, setFirstSearchTerm] = useState("");
  const [secondSearchTerm, setSecondSearchTerm] = useState("");
  const [isOpenBasicInfo, setIsOpenBasicInfo] = useState(true);
  const [isOpenAssignStudent, setIsOpenAssignStudent] = useState(true);
  const [selectedMentor, setSelectedMentor] = useState("N/A");
  const [sessionData, setSessionData] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedCoachingModeId, setSelectedCoachingModeId] = useState("");
  const searchParams = new URLSearchParams(location.search);
  const batchId = searchParams.get("batchId");
  const accessToken = localStorage.getItem("other");
  const [batchStatus, setBatchStatus] = useState(1);

  // ✅ Options use numeric id — same pattern as courses/classes/sessions
  const coachingModeOptions = [
    { id: 1, label: "Online" },
    { id: 2, label: "Classroom" },
    { id: 3, label: "Hybrid" },
  ];

  // ✅ Map id → abbreviation for batch code generation
  const coachingModeIdToAbbr = {
    1: "OL",
    2: "CL",
    3: "H",
  };

  const handleStyle = {
    borderRadius: 0,
    backgroundColor: "#EFEFEF",
    border: "2px solid #999999",
    height: "28px",
    width: "20px",
    opacity: 1,
  };

  const trackStyle = {
    backgroundColor: "#D6D6D6",
    height: "20px",
    border: "1px solid #999999",
  };

  const railStyle = {
    borderRadius: 0,
    backgroundColor: "#FFFFFF",
    height: "20px",
    border: "2px solid #999999",
  };

  const handleToggleChange = (type, val, typeId) => {
    if (val === 1) {
      setActiveToggle(type);
      setStudentTypeId(typeId);
      setToggleKey((prev) => prev + 1);
    } else {
      setActiveToggle(null);
      setStudentTypeId(null);
    }
  };

  const toggleBasicInfoAccordion = () => setIsOpenBasicInfo((prev) => !prev);
  const toggleAssignStudentAccordion = () =>
    setIsOpenAssignStudent((prev) => !prev);

  useEffect(() => {
    if (batchData?.class_id && selectedClass.length > 0) {
      const cls = selectedClass.find(
        (item) => item.class_id === batchData.class_id
      );
      if (cls) {
        setSelectedClassObj(cls);
      }
    }
  }, [selectedClass, batchData]);

  useEffect(() => {
    if (!batchData) return;
    setBatchName(batchData.batch_name || "");
    setBatchDescription(batchData.batch_description || "");
    setBatchCode(batchData.batch_code || "");
    setSelectedSessionId(batchData.session_id || "");
    setSelectedCourseId(batchData.course_id || "");
    setSelectedClassId(batchData.class_id || "");

    // ✅ Store coaching_mode_id directly as numeric ID (same as course_id, class_id, session_id)
    setCoachingMode(batchData.coaching_mode_id || "");

    setSelectedCourseName(batchData.course_name || "");
    setSelectedClassName(batchData.class_name || "");
    setBatchStatus(batchData.status === "Active" ? 1 : 0);

    if (batchData.exam_date) {
      const date = new Date(batchData.exam_date);
      setTentativeExamDate(
        `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
      );
    }
  }, [batchData]);

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
      const data = await response.json();
      setCourses(data);
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-classes/`);
      const data = await response.json();
      setSelectedClass(data);
    };
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedCourseId && selectedClassObj && studentTypeId) {
      const fetchStudentData = async () => {
        const response = await fetch(
          `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
        );
        let data = await response.json();
        data = mapEmptyBatchToNoBatch(data);
        setStudentData(data);
      };
      fetchStudentData();
    }
  }, [selectedCourseId, selectedClassObj, studentTypeId]);

  const handleCourseSelection = (selectedCourseId) => {
    const selectedCourse = courses.find(
      (course) => course.course_id === selectedCourseId
    );
    setSelectedCourseId(selectedCourse.course_id);
    setSelectedCourseName(selectedCourse.course_name);
  };

  const handleClassSelection = (selectedClassId) => {
    const selectedClassObj = selectedClass.find(
      (classObj) => classObj.class_id === selectedClassId
    );
    setSelectedClassObj(selectedClassObj);
    setSelectedClassName(selectedClassObj.class_name);
  };

  // ✅ handleCoachingModeSelection — same pattern as handleCourseSelection / handleClassSelection
  const handleCoachingModeSelection = (selectedId) => {
    setCoachingMode(selectedId);
  };

  const unassignStudents = () => {
    const selectedStudentsCopy = secondTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );
    setFirstTableData((prevFirstTableData) => [
      ...prevFirstTableData,
      ...selectedStudentsCopy,
    ]);
    const newSecondTableData = secondTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );
    setSecondTableData(newSecondTableData);
    setSelectedStudentIds([]);
  };

  // ✅ batchCode uses coachingModeIdToAbbr[coachingMode] since coachingMode is now an ID
  // useEffect(() => {
  //   const abbr = coachingModeIdToAbbr[coachingMode] || "";
  //   const newBatchCode = `${selectedCourseName}-${selectedClassName}-${abbr}-${batchName}`;
  //   setBatchCode(newBatchCode);
  // }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

  useEffect(() => {
    const abbr = coachingModeIdToAbbr[coachingMode] || "";
    const parts = [
      selectedCourseName,
      selectedClassName,
      abbr,
      batchName,
    ].filter(Boolean);
    setBatchCode(parts.join("-"));
  }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

  const updateBatch = async () => {
    if (
      !batchName ||
      !coachingMode ||
      !selectedCourseId ||
      !selectedClassObj ||
      !selectedSessionId
    ) {
      setIsMessageBoxVisible(true);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please fill all the required fields.</span>
            </div>
          </div>
        );
        if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
      }
      return;
    }

    const accessToken = localStorage.getItem("access_token");
    const examDt = tentativeExamDate
      ? `${tentativeExamDate}-01 00:00:00.000`
      : "";

    // ✅ coaching_mode_id uses coachingMode directly (already a numeric ID)
    // ✅ batch_code uses coachingModeIdToAbbr[coachingMode]
    const payload = {
      batch_id: Number(batchData.batch_id),
      batch_name: batchName,
      batch_description: batchDescription,
      batch_code: `${selectedCourseName}-${selectedClassName}-${
        coachingModeIdToAbbr[coachingMode] || ""
      }-${batchName}`,
      coaching_mode_id: Number(coachingMode),
      tentative_exam_dt: examDt,
      comments_: "",
      status: batchStatus,
      class_id: selectedClassObj.class_id,
      course_id: selectedCourseId,
      user_name: user_name,
    };

    const doUpdate = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/update-batch`, {
          method: "PUT",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Batch Updated Successfully.</span>
              </div>
            </div>
          );
          setActiveImg(InformativeIcon);
        }
        setTimeout(() => {
          navigate("/batch_dashboard");
        }, 2000);
      } catch (error) {
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error updating batch. Please try again.</span>
              </div>
            </div>
          );
          if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
        }
      }
    };

    const hasAssignedStudents = secondTableData.some(
      (student) =>
        student.batch_name !== null && student.batch_name !== "Not Assigned"
    );

    if (hasAssignedStudents) {
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Some students are already batch-assigned. Are you sure you want
                to proceed?
              </span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                  doUpdate();
                }}
              >
                YES
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => setIsMessageBoxVisible(false)}
              >
                NO
              </button>
            </div>
          </div>
        );
        if (setActiveImg && InformativeIcon) setActiveImg(InformativeIcon);
        setIsMessageBoxVisible(true);
      }
    } else {
      doUpdate();
    }
  };

  const deleteBatch = async () => {
    const doDelete = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/delete-batch/${batchData.batch_id}`,
          {
            method: "DELETE",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const result = await response.json();
        if (result.status === 409) {
          setIsMessageBoxVisible(true);
          if (setMessageBox) {
            setMessageBox(
              <div className="Container-messageBOX">
                <div className="messagebox-insider1">
                  <div className="loader-tc"></div>
                  <span>{result.message}</span>
                </div>
              </div>
            );
            setActiveImg(WarningIcon);
          }
          return;
        }
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Batch Deleted Successfully.</span>
              </div>
            </div>
          );
          setActiveImg(InformativeIcon);
        }
        setTimeout(() => navigate("/batch_dashboard"), 2000);
      } catch (error) {
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error deleting batch. Please try again.</span>
              </div>
            </div>
          );
          setActiveImg(ErrorImg);
        }
      }
    };

    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Are you sure you want to deactivate this batch?</span>
          </div>
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px", marginTop: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                doDelete();
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => setIsMessageBoxVisible(false)}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(InformativeIcon);
      setIsMessageBoxVisible(true);
    }
  };

  const handleStudentTypeSelection = (e) => {
    const selectedStudentTypeName = e.target.value;
    const classTypeToId = { Online: 1, Classroom: 2, Hybrid: 3 };
    setStudentTypeId(classTypeToId[selectedStudentTypeName]);
  };

  const mapEmptyBatchToNoBatch = (studentData) => {
    const dataArray = Array.isArray(studentData)
      ? studentData
      : studentData?.data || studentData?.students || [];
    return dataArray.map((student) => ({
      ...student,
      batch_name:
        student.batch_name === "" ? "Not Assigned" : student.batch_name,
    }));
  };

  useEffect(() => {
    setFirstTableData([]);
    setTimeout(() => {
      if (excludeAssigned) {
        setFirstTableData(
          studentData.filter((student) => student.batch_name === null)
        );
      } else {
        setFirstTableData(studentData);
      }
    }, 0);
  }, [excludeAssigned, studentData]);

  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 200 && result.data) {
        const formattedSessions = result.data.map((session) => ({
          id: session.session_id,
          label: session.session_name,
        }));
        setSessionData(formattedSessions);
      }
    } catch (error) {
      console.error("Error fetching sessions data:", error);
    }
  };

  useEffect(() => {
    fetchSessionsData();
  }, []);

  const assignStudents = () => {
    const selectedStudentsCopy = firstTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );
    setSecondTableData((prevSecondTableData) => [
      ...prevSecondTableData,
      ...selectedStudentsCopy,
    ]);
    const newFirstTableData = firstTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );
    setFirstTableData(newFirstTableData);
    setSelectedStudentIds([]);
  };

  const handleCheckboxClick = (studentId) => {
    setSelectedStudentIds((prevSelectedStudentIds) => {
      if (prevSelectedStudentIds.includes(studentId)) {
        return prevSelectedStudentIds.filter((id) => id !== studentId);
      } else {
        return [...prevSelectedStudentIds, studentId];
      }
    });
  };

  const [isEditMode, setIsEditMode] = useState(false);

  const headers = [
    // "Student ID",
    "Roll Number",
    "Student Name",
    // "Batch ID",
    // "Batch Name",
    "Student Type",
    // "Mentor Name"
  ];

  const batchStudentCount = studentData.filter(
    (s) => String(s.batch_id) === String(batchId)
  ).length;
  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Manage Batch</span>
        <div className="cr-header-btn-container">
          <button
            className="create-test-section-btn"
            onClick={() => navigate(`/batch_dashboard`)}
            style={{ backgroundColor: "#ffffff", color: "#424342" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#fa4741";
              e.currentTarget.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.color = "#424342";
            }}
          >
            CANCEL
          </button>
          <button
            className="create-test-section-btn"
            style={{
              boxShadow: "0px 4px 4px 0px #00000040",
              backgroundColor: batchStudentCount > 0 ? "#d3d3d3" : "",
              cursor: batchStudentCount > 0 ? "not-allowed" : "pointer",
              color: batchStudentCount > 0 ? "" : "#424342",
            }}
            disabled={batchStudentCount > 0}
            onMouseEnter={(e) => {
              if (batchStudentCount === 0) {
                e.target.style.backgroundColor = "#fa4741";
                e.target.style.color = "white";
              }
            }}
            onMouseLeave={(e) => {
              if (batchStudentCount === 0) {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#424342";
              }
            }}
            onClick={() => {
              if (batchStudentCount === 0) {
                deleteBatch();
              }
            }}
          >
            DEACTIVATE
          </button>
          {isEditMode ? (
            <button
              className="create-test-section-btn"
              onClick={() => {
                updateBatch();
                setIsEditMode(false);
              }}
              style={{
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                color: "#424342",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#fa4741";
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.color = "#424342";
              }}
            >
              SAVE
            </button>
          ) : (
            <button
              className="create-test-section-btn"
              onClick={() => setIsEditMode(true)}
              style={{
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                color: "#424342",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#fa4741";
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.color = "#424342";
              }}
            >
              EDIT
            </button>
          )}
        </div>
      </div>
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>BATCH DETAILS</h2>
          </div>
          <div className="accordion-btn" onClick={toggleBasicInfoAccordion}>
            {isOpenBasicInfo ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenBasicInfo && (
          <div className="accordion-content-tagging-container">
            <div className="grid-container-tagging">
              <div className="grid-item">
                <FormInputs
                  label="Batch Name"
                  value={batchName}
                  onChange={(e) => setBatchName(e.target.value)}
                  required
                  disabled={!isEditMode}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Description"
                  value={batchDescription}
                  onChange={(e) => setBatchDescription(e.target.value)}
                  required
                  disabled={!isEditMode}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Batch Code"
                  value={batchCode}
                  disabled
                  readOnly
                />
              </div>
              <div className="grid-item">
                <SelectDropdown
                  label="Session"
                  style={{ width: "100%" }}
                  selected={selectedSessionId}
                  setSelected={setSelectedSessionId}
                  options={sessionData}
                  isRequired={true}
                  disabled={true}
                />
              </div>
              <div className="grid-item">
                <SelectDropdown
                  label="Course"
                  selected={selectedCourseId}
                  style={{ width: "100%" }}
                  setSelected={handleCourseSelection}
                  options={courses.map((course) => ({
                    id: course.course_id,
                    label: course.course_name,
                  }))}
                  isRequired={true}
                  disabled={true}
                />
              </div>
              <div className="grid-item">
                <SelectDropdown
                  label="Class"
                  style={{ width: "100%" }}
                  selected={selectedClassObj ? selectedClassObj.class_id : ""}
                  setSelected={handleClassSelection}
                  options={selectedClass.map((classObj) => ({
                    id: classObj.class_id,
                    label: classObj.class_name,
                  }))}
                  isRequired={true}
                  disabled={!isEditMode}
                />
              </div>

              {/* ✅ Coaching Mode — now works exactly like Course/Class/Session dropdowns */}
              <div className="grid-item">
                <SelectDropdown
                  label="Batch Coaching Mode"
                  selected={coachingMode}
                  style={{ width: "100%" }}
                  setSelected={handleCoachingModeSelection}
                  options={coachingModeOptions}
                  isRequired={true}
                  disabled={!isEditMode}
                />
              </div>

              <div className="grid-item">
                <FormInputs
                  label="Tentative Exam Date"
                  type="month"
                  value={tentativeExamDate}
                  onChange={(e) => setTentativeExamDate(e.target.value)}
                  required
                  min={new Date().toISOString().slice(0, 7)}
                  disabled={!isEditMode}
                />
              </div>
              <div className="grid-item">
                <SelectedValue
                  label="Mentor"
                  style={{ width: "100%" }}
                  selected={selectedMentor}
                  setSelected={setSelectedMentor}
                  options={[{ id: "N/A", label: "N/A" }]}
                  isRequired={true}
                  disabled={!isEditMode}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>ASSIGN STUDENT(S)</h2>
          </div>
          <div className="accordion-btn" onClick={toggleAssignStudentAccordion}>
            {isOpenAssignStudent ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenAssignStudent && (
          <div className="accordion-content-tagging-container">
            <div className="accordion-content-tagging-container">
              <div
                style={{
                  gridColumn: "1 / -1",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <SelectedStudentTable
                  batchId={batchId}
                  searchPlaceholder="Search Students..."
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditCreateBatch;
